"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MercadoPagoBasisTheoryPaymentRoute = MercadoPagoBasisTheoryPaymentRoute;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _PaymentProcessor = _interopRequireDefault(require("@/components/payment/PaymentProcessor"));
var _LoadingScreen = _interopRequireDefault(require("@/components/LoadingScreen"));
var _purchaseReader = require("./purchaseReader");
var _MercadoPagoBasisTheoryPending = _interopRequireDefault(require("./MercadoPagoBasisTheoryPending"));
var _mercadoPagoBasisTheoryPayment = require("@/services/mercadoPagoBasisTheoryPayment");
var _MercadoPagoBasisTheoryPaymentProcessor = require("./MercadoPagoBasisTheoryPaymentProcessor");
var _attempt = require("./attempt");
var _routeMode = require("./routeMode");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/** Current tenant flags cannot change ownership of an already submitted payment. */
function MercadoPagoBasisTheoryPaymentRoute(props) {
  var _props$match$params = props.match.params,
    token = _props$match$params.token,
    paymentId = _props$match$params.paymentId;
  var ownership = (0, _react.useMemo)(function () {
    return (0, _attempt.readMercadoPagoBasisTheoryOwnership)(token, paymentId);
  }, [token, paymentId]);
  var hint = (0, _routeMode.readMercadoPagoBasisTheoryRouteMode)(props.location.search);
  var identity = "".concat(token, ":").concat(paymentId);
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    lookup = _useState2[0],
    setLookup = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    verification = _useState4[0],
    setVerification = _useState4[1];
  var lookupState = (lookup === null || lookup === void 0 ? void 0 : lookup.identity) === identity ? lookup.state : undefined;
  (0, _react.useEffect)(function () {
    if (Boolean(ownership) || !hint) return undefined;
    var controller = new AbortController();
    setLookup(undefined);
    void (0, _mercadoPagoBasisTheoryPayment.awaitMercadoPagoBasisTheoryRead)(function (signal) {
      return (0, _purchaseReader.readMercadoPagoPurchase)(token, paymentId, signal);
    }, controller.signal, 30000).then(function (response) {
      if (controller.signal.aborted) return;
      var body = (0, _typeof2["default"])(response) === 'object' && response !== null && 'payload' in response ? response.payload : response;
      if ((0, _typeof2["default"])(body) !== 'object' || body === null || !('id' in body) || typeof body.id !== 'string' && (typeof body.id !== 'number' || !Number.isSafeInteger(body.id) || body.id <= 0) || String(body.id) !== paymentId || !('status' in body) || typeof body.status !== 'string' || !body.status.trim() || !('payment_engine' in body && typeof body.payment_engine === 'string' || 'paymentEngine' in body && typeof body.paymentEngine === 'string') || !('payment_type' in body && typeof body.payment_type === 'string' || 'paymentType' in body && typeof body.paymentType === 'string')) {
        setLookup({
          identity: identity,
          state: 'pending'
        });
        return;
      }
      var marker = 'mercadopago_basis_theory' in body ? body.mercadopago_basis_theory : undefined;
      if (marker !== undefined && typeof marker !== 'boolean') {
        setLookup({
          identity: identity,
          state: 'pending'
        });
        return;
      }
      var payment = (0, _mercadoPagoBasisTheoryPayment.normalizeMercadoPagoBasisTheoryPayment)(response);
      var engine = 'payment_engine' in body ? body.payment_engine : 'paymentEngine' in body ? body.paymentEngine : undefined;
      var paymentType = 'payment_type' in body ? body.payment_type : 'paymentType' in body ? body.paymentType : undefined;
      if (engine === 'mercadopago' && paymentType === 'credit_card' && !payment) {
        setLookup({
          identity: identity,
          state: 'pending'
        });
        return;
      }
      setLookup({
        identity: identity,
        state: marker ? payment ? 'bt' : 'pending' : 'legacy'
      });
    })["catch"](function () {
      if (!controller.signal.aborted) setLookup({
        identity: identity,
        state: 'pending'
      });
    });
    return function () {
      controller.abort();
    };
  }, [identity, token, paymentId, ownership, hint, verification]);
  var mode = ownership !== null && ownership !== void 0 && ownership.challengeCompleted ? 'reconcile' : ownership ? hint !== null && hint !== void 0 ? hint : 'challenge' : lookupState === 'bt' ? hint : undefined;
  (0, _react.useLayoutEffect)(function () {
    if (mode && hint !== mode) {
      props.history.replace((0, _routeMode.mercadoPagoBasisTheoryRoute)(token, paymentId, props.location.search, mode));
    }
  }, [token, paymentId, mode, hint, props.history, props.location.search]);
  if (!ownership && hint && lookupState !== 'legacy' && lookupState !== 'bt') {
    if (lookupState === 'pending') return /*#__PURE__*/_react["default"].createElement(_MercadoPagoBasisTheoryPending["default"], {
      key: identity,
      token: token,
      paymentId: paymentId,
      onVerify: function onVerify() {
        setVerification(function (value) {
          return value + 1;
        });
      }
    });
    return /*#__PURE__*/_react["default"].createElement(_LoadingScreen["default"], null);
  }
  if (!mode) return /*#__PURE__*/_react["default"].createElement(_PaymentProcessor["default"], props);
  return /*#__PURE__*/_react["default"].createElement(_MercadoPagoBasisTheoryPaymentProcessor.MercadoPagoBasisTheoryPaymentProcessor, {
    key: "".concat(token, ":").concat(paymentId),
    token: token,
    paymentId: paymentId,
    history: props.history,
    initialMode: mode,
    search: props.location.search,
    "data-sentry-element": "MercadoPagoBasisTheoryPaymentProcessor",
    "data-sentry-component": "MercadoPagoBasisTheoryPaymentRoute",
    "data-sentry-source-file": "MercadoPagoBasisTheoryPaymentRoute.tsx"
  });
}